"use strict";

const DEFAULTS = {
  ENDPOINT: "https://erp.rwdomain.com/api/v1/rw-catalogs/requests",
  FAILURE_URL: "/pages/catalog-request-failed",
  FORM_ID: "catalog-request-form",
  STREET_INPUT_ID: "street_1",
  STATUS_ID: "catalog-request-status",
  HIDDEN_META_ID: "customer-registration-hash",
  SUBMIT_BUTTON_SELECTOR: ".company_custom_button",
  REQUEST_ID_INPUT_ID: "CatalogRequest-CaptchaScore",
  EMAIL_OTHERS_WRAP_ID: "email-others-address-wrap",
  EMAIL_OTHERS_INPUT_ID: "CatalogRequest-EmailOthersAddress",
  EMAIL_OTHERS_SECTION_ID: "email-others-section",
  EMAIL_INPUT_ID: "CatalogRequest-Email",
  CATALOG_DELIVERY_SECTION_ID: "catalog-delivery-section",
  PHYSICAL_SHIP_OPTION_ID: "physical-ship-option",
  INVENTORY_DATA_ID: "catalog-request-inventory-data",
  MAX_EMAIL_OTHERS_COUNT: 10,
};

let _catalogInventoryData = null;

function getCatalogInventoryData() {
  if (_catalogInventoryData) return _catalogInventoryData;
  const el = document.getElementById(DEFAULTS.INVENTORY_DATA_ID);
  if (!el) {
    _catalogInventoryData = { default: { inventory: 0 }, distributor: { inventory: 0 }, distributorDomains: [] };
    return _catalogInventoryData;
  }
  try {
    _catalogInventoryData = JSON.parse(el.textContent);
  } catch (e) {
    _catalogInventoryData = { default: { inventory: 0 }, distributor: { inventory: 0 }, distributorDomains: [] };
  }
  return _catalogInventoryData;
}

function getEmailDomain(value) {
  const email = (value || "").trim().toLowerCase();
  if (!email.includes("@")) return "";
  const at = email.lastIndexOf("@");
  return email.slice(at + 1);
}

function isValidEmail(value) {
  const email = (value || "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function parseEmailOthersAddresses(value) {
  return (value || "")
    .split(",")
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
}

function validateEmailOthersAddress(form) {
  const input = document.getElementById(DEFAULTS.EMAIL_OTHERS_INPUT_ID);
  if (!input || input.disabled) return true;

  const emails = parseEmailOthersAddresses(input.value);

  if (emails.length === 0) {
    setFieldError(input, "Please enter at least one email address");
    return false;
  }
  if (emails.length > DEFAULTS.MAX_EMAIL_OTHERS_COUNT) {
    setFieldError(input, `Maximum ${DEFAULTS.MAX_EMAIL_OTHERS_COUNT} email addresses allowed`);
    return false;
  }
  const invalid = emails.find((email) => !isValidEmail(email));
  if (invalid) {
    setFieldError(input, `Invalid email address: ${invalid}`);
    return false;
  }
  const seen = new Set();
  const duplicate = emails.find((email) => {
    const key = email.toLowerCase();
    if (seen.has(key)) return true;
    seen.add(key);
    return false;
  });
  if (duplicate) {
    setFieldError(input, `Duplicate email address: ${duplicate}`);
    return false;
  }
  clearFieldError(input);
  return true;
}

function getInventoryBucketForEmail(email) {
  const data = getCatalogInventoryData();
  const domain = getEmailDomain(email);
  if (!domain) return null;
  const distributorDomains = data.distributorDomains || [];
  return distributorDomains.includes(domain) ? "distributor" : "default";
}

function setFieldError(input, message) {
  const field = input.closest(".field");
  if (!field) return;
  field.classList.add("is-invalid");
  let errorEl = field.querySelector(".field-error");
  if (!errorEl) {
    errorEl = document.createElement("div");
    errorEl.className = "field-error";
    field.appendChild(errorEl);
  }
  errorEl.textContent = message;
}

function clearFieldError(input) {
  const field = input.closest(".field");
  if (!field) return;
  field.classList.remove("is-invalid");
  const errorEl = field.querySelector(".field-error");
  if (errorEl) errorEl.remove();
}

function isFieldValueEmpty(input) {
  if (input.tagName === "SELECT") {
    return !input.value || input.value.trim() === "";
  }
  return (input.value || "").trim() === "";
}

function validateRequiredFields(form) {
  const candidates = form.querySelectorAll(
    "input[required], select[required], textarea[required]",
  );
  let firstInvalid = null;

  candidates.forEach((input) => {
    if (input.type === "radio" || input.type === "checkbox") return;
    if (input.disabled) return;
    if (input.closest("[hidden]")) return;
    if (input.id === DEFAULTS.EMAIL_OTHERS_INPUT_ID) return;

    if (isFieldValueEmpty(input) || !input.checkValidity()) {
      setFieldError(input, "This field is required");
      if (!firstInvalid) firstInvalid = input;
    } else {
      clearFieldError(input);
    }
  });

  if (firstInvalid) {
    if (typeof firstInvalid.focus === "function") firstInvalid.focus({ preventScroll: true });
    if (typeof firstInvalid.scrollIntoView === "function") {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  return !firstInvalid;
}

function setElementVisible(el, visible) {
  if (!el) return;
  if (visible) {
    el.removeAttribute("hidden");
    el.style.display = "";
  } else {
    el.setAttribute("hidden", "");
    el.style.display = "none";
  }
}

function syncCatalogDeliveryVisibility(form) {
  const section = document.getElementById(DEFAULTS.CATALOG_DELIVERY_SECTION_ID);
  const shipOption = document.getElementById(DEFAULTS.PHYSICAL_SHIP_OPTION_ID);
  if (!section || !shipOption) return;

  const emailInput = form.querySelector(`#${DEFAULTS.EMAIL_INPUT_ID}`);
  const emailValue = emailInput?.value ?? "";
  const validEmail = isValidEmail(emailValue);
  const shipRadio = form.querySelector("#CatalogRequest-PhysicalYes");
  const emailRadio = form.querySelector("#CatalogRequest-PhysicalNo");

  if (!validEmail) {
    setElementVisible(section, false);
    setElementVisible(shipOption, false);
    if (shipRadio) shipRadio.checked = false;
    if (emailRadio) emailRadio.checked = true;
    return;
  }

  setElementVisible(section, true);

  const bucket = getInventoryBucketForEmail(emailValue);
  const data = getCatalogInventoryData();
  const inventory = Number(data?.[bucket]?.inventory ?? 0);
  const shipWasHidden = shipOption.hasAttribute("hidden");

  if (inventory > 0) {
    setElementVisible(shipOption, true);
    if (shipWasHidden && shipRadio && emailRadio) {
      shipRadio.checked = true;
      emailRadio.checked = false;
    }
  } else {
    setElementVisible(shipOption, false);
    if (shipRadio && shipRadio.checked) shipRadio.checked = false;
    if (emailRadio) emailRadio.checked = true;
  }
}

let _autocompleteStreet1 = null;

function generateRequestId() {
  if (window.crypto?.getRandomValues) {
    const digits = new Uint8Array(16);
    window.crypto.getRandomValues(digits);
    return Array.from(digits, (digit) => String(digit % 10)).join("");
  }

  return `${Date.now()}${Math.floor(Math.random() * 1000000)}`
    .replace(/\D/g, "")
    .slice(0, 16)
    .padEnd(16, "0");
}

function refreshRequestId() {
  const requestId = generateRequestId();
  setHiddenFieldValue(DEFAULTS.REQUEST_ID_INPUT_ID, requestId);

  const meta = document.getElementById(DEFAULTS.HIDDEN_META_ID);
  if (meta) {
    meta.dataset.requestId = requestId;
  }

  return requestId;
}

function syncPlaceholderOverlay(input, focused = false) {
  const field = input.closest(".field");
  if (!field) return;

  let placeholder = field.querySelector(".catalog-request-faux-placeholder");
  if (!placeholder) {
    placeholder = document.createElement("span");
    placeholder.className = "catalog-request-faux-placeholder";
    placeholder.setAttribute("aria-hidden", "true");
    if (input.tagName === "TEXTAREA") {
      input.insertAdjacentElement("afterend", placeholder);
    } else {
      field.insertBefore(placeholder, input);
    }
  }

  placeholder.textContent = input.getAttribute("placeholder") || "";
  placeholder.hidden = Boolean(input.value) || focused;
}

function syncPlaceholderOverlayById(id) {
  const input = document.getElementById(id);
  if (input) syncPlaceholderOverlay(input);
}

function syncAllPlaceholderOverlays(form) {
  const inputs = form.querySelectorAll(
    'input[placeholder]:not([type="radio"]):not([type="checkbox"]), textarea[placeholder]',
  );

  inputs.forEach((input) => syncPlaceholderOverlay(input));
}

function initPlaceholderOverlays(form) {
  const inputs = form.querySelectorAll(
    'input[placeholder]:not([type="radio"]):not([type="checkbox"])',
  );

  inputs.forEach((input) => {
    syncPlaceholderOverlay(input);
    input.addEventListener("input", () => syncPlaceholderOverlay(input));
    input.addEventListener("change", () => syncPlaceholderOverlay(input));
    input.addEventListener("focus", () => syncPlaceholderOverlay(input, true));
    input.addEventListener("blur", () => syncPlaceholderOverlay(input));
  });
}

function getHiddenFieldValue(id) {
  return document.getElementById(id)?.value?.trim() ?? "";
}

function setHiddenFieldValue(id, value) {
  const el = document.getElementById(id);
  if (el) el.value = value;
}

function syncCountryCode(form) {
  const countrySelect = form.querySelector("#CatalogRequest-Country");
  if (!countrySelect) return "";

  const selectedOption = countrySelect.selectedOptions?.[0];
  const code = (countrySelect.value || selectedOption?.value || "").trim();
  setHiddenFieldValue("CatalogRequest-CountryCode", code);
  return code;
}

function getAutocompleteCountryRestriction() {
  const countrySelect = document.getElementById("CatalogRequest-Country");
  const selectedText = countrySelect?.selectedOptions?.[0]?.textContent?.trim() ?? "United States";

  if (selectedText === "Canada") return "ca";
  return "us";
}

function updateAutocompleteCountryRestriction() {
  if (!_autocompleteStreet1 || typeof google === "undefined" || !google.maps?.places) return;

  const country = getAutocompleteCountryRestriction();
  if (typeof _autocompleteStreet1.setComponentRestrictions === "function") {
    _autocompleteStreet1.setComponentRestrictions({ country });
  }
}

function limitCountries(form) {
  const countrySelect = form.querySelector("#CatalogRequest-Country");
  if (!countrySelect) return;

  const allowedCountries = new Set(["United States", "Canada"]);
  const placeholderOption = Array.from(countrySelect.options).find((option) => option.disabled && option.hidden);
  const allowedOptions = Array.from(countrySelect.options).filter((option) => {
    const text = option.textContent.trim();
    return !option.disabled && !option.hidden && allowedCountries.has(text);
  });

  countrySelect.innerHTML = "";

  if (placeholderOption) {
    countrySelect.appendChild(placeholderOption);
  }

  allowedOptions.forEach((option) => {
    countrySelect.appendChild(option);
  });

  if (!countrySelect.value) {
    const defaultOption = allowedOptions.find((option) => option.textContent.trim() === "United States") || allowedOptions[0];
    if (defaultOption) {
      countrySelect.value = defaultOption.value;
      syncCountryCode(form);
    }
  }

  updateAutocompleteCountryRestriction();
}

function syncStateCode(form) {
  const stateInput = form.querySelector("#CatalogRequest-State");
  if (!stateInput) return "";

  const rawValue = stateInput.value.trim();
  const code = (stateInput.dataset.stateCode || "").trim() || (rawValue.length === 2 ? rawValue.toUpperCase() : "");

  setHiddenFieldValue("CatalogRequest-StateCode", code);
  return code;
}

function onlyNumberKey(evt) {
  const code = evt.which ?? evt.keyCode;
  if (code === 8 || code === 46) return true;
  return /[0-9()+\s-]/.test(String.fromCharCode(code));
}

function initAutocomplete() {
  const streetInput = document.getElementById(DEFAULTS.STREET_INPUT_ID);
  if (!streetInput || typeof google === "undefined" || !google.maps?.places) return;

  streetInput.addEventListener("focus", geolocate, true);
  _autocompleteStreet1 = new google.maps.places.Autocomplete(streetInput, {
    types: ["geocode"],
    componentRestrictions: { country: getAutocompleteCountryRestriction() },
  });
  _autocompleteStreet1.addListener("place_changed", fillInAddress);
}

function geolocate() {
  if (!navigator.geolocation || !_autocompleteStreet1) return;

  navigator.geolocation.getCurrentPosition(({ coords }) => {
    const circle = new google.maps.Circle({
      center: { lat: coords.latitude, lng: coords.longitude },
      radius: coords.accuracy,
    });
    _autocompleteStreet1.setBounds(circle.getBounds());
  });
}

function fillInAddress() {
  if (!_autocompleteStreet1) return;

  const place = _autocompleteStreet1.getPlace();
  if (!place?.address_components) return;

  const setValue = (id, value) => {
    const el = document.getElementById(id);
    if (el) el.value = value;
  };

  let streetNumber = "";
  let streetRoute = "";

  place.address_components.forEach(({ types, long_name, short_name }) => {
    if (types.includes("street_number")) streetNumber = long_name;
    if (types.includes("route")) streetRoute = long_name;
    if (types.includes("locality")) setValue("CatalogRequest-City", long_name);
    if (types.includes("administrative_area_level_1")) {
      setValue("CatalogRequest-State", long_name);
      setValue("CatalogRequest-StateCode", short_name);
      const stateInput = document.getElementById("CatalogRequest-State");
      if (stateInput) {
        stateInput.dataset.stateCode = short_name;
      }
    }
    if (types.includes("postal_code")) setValue("CatalogRequest-Zip", long_name);
    if (types.includes("country")) {
      const countrySelect = document.getElementById("CatalogRequest-Country");
      if (countrySelect) {
        const option = Array.from(countrySelect.options).find((opt) => opt.text === long_name);
        if (option) countrySelect.value = option.value;
      }
      setHiddenFieldValue("CatalogRequest-CountryCode", short_name);
    }
  });

  setValue(DEFAULTS.STREET_INPUT_ID, [streetNumber, streetRoute].filter(Boolean).join(" "));
  syncPlaceholderOverlayById(DEFAULTS.STREET_INPUT_ID);
  syncPlaceholderOverlayById("CatalogRequest-City");
  syncPlaceholderOverlayById("CatalogRequest-State");
  syncPlaceholderOverlayById("CatalogRequest-Zip");
  syncCountryCode(document.getElementById(DEFAULTS.FORM_ID));
  updateAutocompleteCountryRestriction();
}

function syncEmailOthersAddressRequirement(form) {
  const wrap = document.getElementById(DEFAULTS.EMAIL_OTHERS_WRAP_ID);
  const input = document.getElementById(DEFAULTS.EMAIL_OTHERS_INPUT_ID);
  const sectionVisible = isEmailOthersSectionVisible(form);
  const selected = sectionVisible && form.querySelector('input[name="emailOthers"]:checked')?.value === "true";

  if (!wrap || !input) return;

  if (selected) {
    wrap.removeAttribute("hidden");
    wrap.style.display = "block";
  } else {
    wrap.setAttribute("hidden", "");
    wrap.style.display = "none";
  }
  input.required = selected;
  input.disabled = !selected;
  input.setAttribute("aria-hidden", String(!selected));
  if (!selected) {
    input.value = "";
    input.setCustomValidity("");
  }
}

function isEmailOthersSectionVisible(form) {
  return form.querySelector('input[name="physicalCatalog"]:checked')?.value === "false";
}

function syncEmailOthersSectionVisibility(form) {
  const section = document.getElementById(DEFAULTS.EMAIL_OTHERS_SECTION_ID);
  if (!section) return;

  const visible = isEmailOthersSectionVisible(form);
  const radios = form.querySelectorAll('input[name="emailOthers"]');

  if (visible) {
    section.removeAttribute("hidden");
    section.style.display = "";
  } else {
    section.setAttribute("hidden", "");
    section.style.display = "none";
    const noRadio = form.querySelector('#CatalogRequest-EmailOthersNo');
    if (noRadio) noRadio.checked = true;
  }

  radios.forEach((radio) => {
    radio.disabled = !visible;
  });

  syncEmailOthersAddressRequirement(form);
}

function setDefaultCountry() {
  const countrySelect = document.getElementById("CatalogRequest-Country");
  if (!countrySelect || countrySelect.value) return;

  const defaultOption = Array.from(countrySelect.options).find(
    (option) => option.textContent.trim() === "United States",
  );

  if (defaultOption) {
    countrySelect.value = defaultOption.value;
    setHiddenFieldValue("CatalogRequest-CountryCode", defaultOption.value);
  }
}

function showLoadingState(submitBtn, spinnerElement) {
  if (spinnerElement) spinnerElement.style.display = "block";
  if (submitBtn) submitBtn.disabled = true;
}

function hideLoadingState(submitBtn, spinnerElement) {
  if (spinnerElement) spinnerElement.style.display = "none";
  if (submitBtn) submitBtn.disabled = false;
}

function getFormValue(form, id) {
  const el = document.getElementById(id) || form.querySelector(`#${id}`);
  return el?.value?.trim() ?? "";
}

function getCheckedValue(form, name) {
  return form.querySelector(`input[name="${name}"]:checked`)?.value ?? "";
}

function normalizeAddress(address, city, zip) {
  return [address, city, zip]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .replace(/[^\w\s-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function collectCatalogRequestPayload(form) {
  const address = getFormValue(form, DEFAULTS.STREET_INPUT_ID);
  const city = getFormValue(form, "CatalogRequest-City");
  const state = getFormValue(form, "CatalogRequest-State");
  const stateCode = getFormValue(form, "CatalogRequest-StateCode") || syncStateCode(form);
  const zip = getFormValue(form, "CatalogRequest-Zip");
  const countrySelect = form.querySelector("#CatalogRequest-Country");
  const country = countrySelect?.selectedOptions?.[0]?.textContent?.trim() ?? "";
  const countryCode = getFormValue(form, "CatalogRequest-CountryCode") || syncCountryCode(form);
  const meta = document.getElementById(DEFAULTS.HIDDEN_META_ID);
  const requestId = meta?.dataset.requestId || "";
  const hashKey = meta?.dataset.hashKey || "";

  return {
    firstName: getFormValue(form, "CatalogRequest-FirstName"),
    lastName: getFormValue(form, "CatalogRequest-LastName"),
    company: getFormValue(form, "CatalogRequest-Company"),
    jobTitle: getFormValue(form, "CatalogRequest-JobTitle"),
    email: getFormValue(form, "CatalogRequest-Email"),
    phone: getFormValue(form, "CatalogRequest-Phone"),
    address,
    city,
    state,
    stateCode,
    zip,
    country,
    countryCode,
    salesRep: getCheckedValue(form, "salesRep") === "true",
    physicalCatalog: getCheckedValue(form, "physicalCatalog") === "true",
    emailOthers: getCheckedValue(form, "emailOthers") === "true",
    emailOthersAddress: parseEmailOthersAddresses(getFormValue(form, DEFAULTS.EMAIL_OTHERS_INPUT_ID)).join(","),
    normalizedAddress: normalizeAddress(address, city, zip),
    status: "completed",
    requestId: requestId,
    hashKey: hashKey,
  };
}

function showStatus(message, isError = false) {
  const statusEl = document.getElementById(DEFAULTS.STATUS_ID);
  if (!statusEl) return;
  if (!message) {
    statusEl.textContent = "";
    statusEl.hidden = true;
    return;
  }
  statusEl.textContent = message;
  statusEl.hidden = false;
  statusEl.style.color = isError ? "var(--color-error, #b00020)" : "rgb(var(--color-foreground-title))";
}

async function submitFormToAPI(payload) {
  const meta = document.getElementById(DEFAULTS.HIDDEN_META_ID);
  const submitBtn = document.querySelector(DEFAULTS.SUBMIT_BUTTON_SELECTOR);
  const spinnerElement = document.querySelector(".customer_login_spinner");
  const requestId = meta?.dataset.requestId;
  const hashKey = meta?.dataset.hashKey;
  const endpoint = meta?.dataset.endpoint || DEFAULTS.ENDPOINT;

  if (!requestId || !hashKey) {
    showStatus("Missing request token. Please refresh and try again.", true);
    return;
  }

  showLoadingState(submitBtn, spinnerElement);
  showStatus("");

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    let data = {};
    try {
      data = await response.json();
    } catch (error) {
      data = {};
    }

    if (response.ok && data.code === 0) {
      if (data.redirectUrl) {
        window.location.href = data.redirectUrl;
        return;
      }
      hideLoadingState(submitBtn, spinnerElement);
      showStatus("Your request has been received.");
      if (submitBtn) submitBtn.querySelector("span:nth-child(2)").textContent = "Request Submitted";
      if (submitBtn) submitBtn.disabled = true;
      return;
    }

    hideLoadingState(submitBtn, spinnerElement);
    window.location.href = `${DEFAULTS.FAILURE_URL}?statusCode=${response.status}`;
  } catch (error) {
    hideLoadingState(submitBtn, spinnerElement);
    window.location.href = `${DEFAULTS.FAILURE_URL}?statusCode=500`;
  }
}

function initializeFormHandler() {
  const form = document.getElementById(DEFAULTS.FORM_ID);
  if (!form) return;

  initPlaceholderOverlays(form);
  syncAllPlaceholderOverlays(form);
  limitCountries(form);
  setDefaultCountry();
  syncCatalogDeliveryVisibility(form);
  syncEmailOthersSectionVisibility(form);
  syncStateCode(form);
  syncCountryCode(form);

  window.requestAnimationFrame(() => {
    syncAllPlaceholderOverlays(form);
  });

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      form.reset();
      limitCountries(form);
      setDefaultCountry();
      syncCountryCode(form);
      syncStateCode(form);
      syncCatalogDeliveryVisibility(form);
      syncEmailOthersSectionVisibility(form);
    }
    syncAllPlaceholderOverlays(form);
  });

  const countrySelect = document.getElementById("CatalogRequest-Country");
  if (countrySelect) {
    countrySelect.addEventListener("change", () => {
      syncCountryCode(form);
      syncStateCode(form);
      updateAutocompleteCountryRestriction();
    });
  }

  const stateInput = document.getElementById("CatalogRequest-State");
  if (stateInput) {
    stateInput.addEventListener("input", () => {
      if (stateInput.value.trim().length !== 2) {
        delete stateInput.dataset.stateCode;
      }
      syncStateCode(form);
    });
    stateInput.addEventListener("blur", () => {
      syncStateCode(form);
    });
  }

  const emailInput = document.getElementById(DEFAULTS.EMAIL_INPUT_ID);
  if (emailInput) {
    emailInput.addEventListener("input", () => {
      syncCatalogDeliveryVisibility(form);
      syncEmailOthersSectionVisibility(form);
    });
    emailInput.addEventListener("blur", () => {
      syncCatalogDeliveryVisibility(form);
      syncEmailOthersSectionVisibility(form);
    });
  }

  const emailOthersRadios = form.querySelectorAll('input[name="emailOthers"]');
  emailOthersRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      syncEmailOthersAddressRequirement(form);
    });
  });

  const physicalCatalogRadios = form.querySelectorAll('input[name="physicalCatalog"]');
  physicalCatalogRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      syncEmailOthersSectionVisibility(form);
    });
  });

  form.addEventListener("change", () => {
    syncEmailOthersSectionVisibility(form);
  });

  form.addEventListener("input", (event) => {
    const target = event.target;
    if (!target || !target.closest || !target.closest(".field")) return;
    if (target.type === "radio" || target.type === "checkbox") return;
    if (!isFieldValueEmpty(target) && target.checkValidity()) {
      clearFieldError(target);
    }
  });

  form.addEventListener("change", (event) => {
    const target = event.target;
    if (!target || !target.closest || !target.closest(".field")) return;
    if (target.tagName !== "SELECT") return;
    if (!isFieldValueEmpty(target) && target.checkValidity()) {
      clearFieldError(target);
    }
  });

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    syncEmailOthersSectionVisibility(form);

    if (!validateRequiredFields(form)) {
      return;
    }

    if (!validateEmailOthersAddress(form)) {
      return;
    }

    const payload = collectCatalogRequestPayload(form);
    const normalizedInput = document.getElementById("CatalogRequest-NormalizedAddress");
    if (normalizedInput) normalizedInput.value = payload.normalizedAddress;
    const captchaInput = document.getElementById(DEFAULTS.REQUEST_ID_INPUT_ID);
    if (captchaInput && !captchaInput.value) {
      captchaInput.value = payload.hashKey;
    }

    submitFormToAPI(payload);
  });
}

document.addEventListener("DOMContentLoaded", initializeFormHandler);
